import { render } from "./ResultsTable.vue?vue&type=template&id=81c7c036"
import script from "./ResultsTable.vue?vue&type=script&lang=js"
export * from "./ResultsTable.vue?vue&type=script&lang=js"

import "./ResultsTable.vue?vue&type=style&index=0&id=81c7c036&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox});
